export class ServiceType {
    id:number = 0;
    description:string = '';
}
